import FormControlLabel from "@material-ui/core/FormControlLabel";
import { FormEvent } from "react";
import { SwitchBlue } from "../../../../../../libs/switch";
import useEletronicInventoryStore from "../store/useStore";
import RowFiveAndSix from "./RowInputs/RowFiveAndSix";
import RowNine from "./RowInputs/RowNine";
import RowOneAndTwo from "./RowInputs/RowOneAndTwo";
import RowSevenAndEight from "./RowInputs/RowSevenAndEight";
import RowTreeAndFour from "./RowInputs/RowTreeAndFour";

export function FormInputRows({ handleSubmitForm }) {
  const { defaultValues, createOrUpdate, state } = useEletronicInventoryStore();
  const { setState } = useEletronicInventoryStore();
  const { handleExitClick } = useEletronicInventoryStore();
  return (
    <form onSubmit={(event: FormEvent) => handleSubmitForm(event)} className="box-form form-container">
      <RowOneAndTwo />
      <RowTreeAndFour />
      <RowFiveAndSix />
      <RowSevenAndEight />
      <RowNine />

      <div className="box-row padding-1-rem">
        <button className="btn bg-primary" type="submit">
          Salvar
        </button>
        <button className="btn bg-secondary" type="button" onClick={handleExitClick}>
          Cancelar
        </button>
        {createOrUpdate === "update" && (
          <div className="form-input switch switch-eletronics ">
            {!state ? (
              <div className="color-text font-roboto">
                <span>Status do Bem - </span>
                <span className="status-item-active font-source-sans-pro bold font-15px"> Ativo</span>
              </div>
            ) : (
              <div className="color-text font-roboto">
                <span>Status do Bem - </span>
                <span className="status-item-inactive font-source-sans-pro bold font-15px"> Inativo</span>
              </div>
            )}
          </div>
        )}
      </div>
    </form>
  );
}
